import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import SvgIcon from 'src/components/SvgIcon'
import styles from './CardRow.module.less'

const CardRow = ({ children, className }) => {
  const classNames = cx({
    [styles.row]: true,
    [className]: !!className,
  })

  return <div className={classNames}>{children}</div>
}
CardRow.propTypes = {
  className: PropTypes.string,
  sideContent: PropTypes.func,
}

const CardRowIcon = ({ svgIcon }) =>
  !svgIcon ? (
    ''
  ) : (
    <div className={styles.iconHolder}>
      <SvgIcon type={svgIcon} className={styles.icon} />
    </div>
  )
CardRowIcon.propTypes = {
  svgIcon: PropTypes.string,
}

const CardRowMain = ({ children, className }) => {
  if (!children) {
    return ''
  }

  const classNames = cx({
    [styles.main]: true,
    [className]: !!className,
  })

  return <div className={classNames}>{children}</div>
}
CardRowMain.propTypes = {
  svgIcon: PropTypes.string,
}

const CardRowSide = ({ children, className }) => {
  if (!children) {
    return ''
  }

  const classNames = cx({
    [styles.side]: true,
    [className]: !!className,
  })

  return <div className={classNames}>{children}</div>
}

const CardRowLink = ({ children, href, ...rest }) =>
  !children ? (
    ''
  ) : (
    <a href={href} target='_blank' rel='noopener noreferrer' className={styles.link} {...rest}>
      {children}
    </a>
  )
CardRowLink.propTypes = {
  href: PropTypes.string,
}

export { CardRow, CardRowIcon, CardRowMain, CardRowSide, CardRowLink }
